import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import Swal from 'sweetalert2'
import {
  Row,
  Col,
  FormGroup,
  Input,
  Button
} from 'reactstrap';

export default class LoginPage extends React.Component{
  constructor(props){
        super(props);
        this.state = {email:"", password:""};
    }

    loginAction() {
      let storage = window.localStorage;
      axios.post(storage.ch_action_url+"/action/admin_login", Qs.stringify({
        email:this.state.email,
        password:this.state.password,
      })).then( res => {
        console.log(res);
        if(res.data.status=== 0){
          storage.setItem('ch_admin_uid', "");
          storage.setItem('ch_admin_uname', "");
          storage.setItem('ch_admin_uimage', "");
          storage.setItem('ch_admin_token', "");
          //storage.setItem('ch_admin_token', "");
          Swal.fire(
            'Email or Password may be not correct!',
            'Please try again!',
            'error');
        }
        else {
          let user=res.data.data;
          storage.setItem('ch_admin_uid', user.uid);
          storage.setItem('ch_admin_uname', user.uname);
          storage.setItem('ch_admin_uimage', user.uimage);
          storage.setItem('ch_admin_token', user.token);
          window.location.href=window.location.origin +  "/admin";
        }

      }).catch(error => {
          console.log(error);
      });
    }

  render(){
    return (
    <Fragment>
      <div className="app-wrapper min-vh-100">
        <div className="app-main min-vh-100">
          <div className="app-content p-0">
            <div className="app-content--inner d-flex align-items-center">
              <div className="flex-grow-1 w-100 d-flex align-items-center">
                <div className="bg-composed-wrapper--content py-5">
                        <div className="pl-0 pl-md-5" style={{maxWidth:'600px', margin:"auto"}}>
                          <div className="text-black mt-3">
                            <span className="text-left text-sm-center">
                              <h1 className="display-3 text-lg-left text-center mb-3 font-weight-bold">
                                {"Admin Login Page"}
                              </h1>
                            </span>
                            <div>
                              <form>
                                <FormGroup>
                                  <label>{"Email"}</label>
                                  <Input
                                    placeholder="yourname@yourmail.com"
                                    type="email"
                                    onChange={(event) => {this.setState({email:event.target.value})}}
                                    value={this.state.email}
                                  />
                                </FormGroup>
                                <div className="form-group mb-4">
                                  <div className="d-flex justify-content-between">
                                    <label>{"Password"}</label>
                                  </div>
                                  <Input
                                    //placeholder="Enter your password"
                                    type="password"
                                    onChange={(event) => {this.setState({password:event.target.value})}}
                                    value={this.state.password}
                                  />
                                </div>

                                <Button size="lg" block={true} color="second" onClick={() => {this.loginAction()}}>
                                  {"Sing in"}
                                </Button>
                              </form>
                            </div>
                          </div>
                        </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );}
}
